var _use, _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureSynapse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 126 145",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5 0L0 36v72l62.5 36 62.5-36V36zM114 101l-51.5 30L11 101V43l51.5-30L114 43v49.5z",
    stroke: "#0078d1",
    fill: "#0078d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.472 72.07c-1.022 0-1.997.093-2.926.28-7.337-9.517-18.157-15.862-30.044-17.541L106 24.905 94.02 18 46.933 45.338a14.67 14.67 0 0 0-8.684-2.846c-8.126 0-14.72 6.625-14.72 14.789s6.594 14.789 14.72 14.789c4.69 0 8.916-2.239 11.609-5.692 9.798.56 18.899 5.318 24.936 12.923-1.3 2.193-2.043 4.759-2.043 7.511 0 .513.046 1.073.093 1.586L19.25 119l12.5 7.25 47.038-27.495a14.67 14.67 0 0 0 8.684 2.846c8.126 0 14.72-6.625 14.72-14.789 0-8.117-6.594-14.742-14.72-14.742z",
    stroke: "#50e6ff",
    fill: "#50e6ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureSynapse);
export default __webpack_public_path__ + "static/media/azure_synapse.a0f4acd1b7daee62f899b3a599a56cd1.svg";
export { ForwardRef as ReactComponent };